module.exports = __webpack_public_path__ + "img/XML解析@3x.png";